<template>
  <a
    :href="product.url"
    :class="b('', { variant, highlight })"
  >
    <div :class="b('image-container')">
      <e-picture
        v-if="image"
        :srcset="image.srcset"
        :alt="image?.alt || image?.title || product?.textDifferentiating || product?.sku"
        :title="image.title"
        :fallback="image.fallback"
        :ratio="1"
        :sizes="pictureSizes"
        :placeholder="!image"
        loading="lazy"
        :class="b('image')"
      />
      <e-picture
        v-else
        :ratio="1"
        :sizes="pictureSizes"
        :placeholder="!image"
        loading="lazy"
        :class="b('image')"
        :alt="product.textDifferentiating || product.sku"
      />
    </div>
    <div :class="b('differentiating-sku-wrapper')">
      <div :class="b('differentiating')">
        {{ product.textDifferentiating }}
      </div>
      <div :class="b('sku')">{{ product.sku }}</div>
    </div>
  </a>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { PRODUCT_DISPLAY_PICTURE_SIZES } from '@/setup/globals';
  import ePicture from '@/elements/e-picture.vue';
  import type { Image } from '@/types/image';
  import { ProductBase } from '@/types/product';
  import { ImageSizes } from '@/types/sizes';

  export enum DesignVariant {
    List = 'list',
  }

  // type Setup = {};

  type Data = {
    pictureSizes: ImageSizes;
  };

  /**
   * Renders a product variant item.
   */
  export default defineComponent({
    name: 'c-product-variant',
    components: {
      ePicture,
    },

    props: {
      /**
       * The product to be displayed.
       */
      product: {
        type: Object as PropType<ProductBase>,
        required: true,
      },

      /**
       * Define the display variant.
       */
      variant: {
        type: String,
        default: DesignVariant.List,
        validator: (value: DesignVariant) => [DesignVariant.List].includes(value),
      },

      /**
       * Define if the item should be highlighted.
       */
      highlight: {
        type: Boolean,
        default: false,
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    data(): Data {
      return {
        pictureSizes: PRODUCT_DISPLAY_PICTURE_SIZES,
      };
    },

    computed: {
      image(): Image | null {
        return this.product?.mainImage || this.product?.images?.[0] || null;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-product-variant {
    $this: &;

    &--variant-list {
      @include mixins.hover-effect--default;

      display: grid;
      grid-template-columns: var(--theme-image-size--md) 1fr;
      align-items: flex-start;
      margin-bottom: 1rem;
      gap: 0.5rem;

      @include mixins.media(sm) {
        &:hover {
          #{$this}__differentiating {
            text-decoration: underline;
          }
        }
      }

      #{$this}__differentiating {
        @include mixins.line-clamp(3, 1.2);

        font-weight: bold;
      }
    }

    &__differentiating-sku-wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 1rem;
    }

    &__sku {
      font-size: variables.$font-size--smallest;
    }

    &--highlight#{$this}--variant-list {
      #{$this}__image {
        border: 3px solid variables.$va-color-grayscale--0;
        box-shadow: 0 12px 12px -8px rgba(0, 0, 0, 40%);
      }
    }
  }
</style>
